import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import ChecklistIcon from "@mui/icons-material/ChecklistRounded";
import { Box, Stack } from "@mui/material";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { ExcelReportParameterType, WorkbookFilter } from "../../../../../../api/types/workbookRuns.types";
import WorkbookFilterItemLabelLinkedCounter from "./WorkbookFilterItemLabelLinkedCounter";
import WorkbookFilterLabelLogo from "./WorkbookFilterLabelLogo";

interface Props {
  filter: WorkbookFilter;
  showCompanyLogo?: boolean;
}

const getFilterIcon = (type: ExcelReportParameterType) => {
  switch (type) {
    case "Date":
    case "Daterange":
      return <CalendarTodayRoundedIcon color="action" />;
    case "Table":
      return <ChecklistIcon color="action" />;
    default:
      return null;
  }
};

const WorkbookFilterItemLabel = ({ filter, showCompanyLogo }: Props) => {
  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", minWidth: 0 }}>
      {getFilterIcon(filter.type)}
      <Stack sx={{ minWidth: 0, justifyContent: "center" }}>
        <Box sx={{ minWidth: 0, display: "flex", gap: 0.5, alignItems: "center" }}>
          <TypographyTooltipEllipsis text={filter.name ?? ""} tooltipProps={{ disableInteractive: true }} />
          {showCompanyLogo && <WorkbookFilterLabelLogo clientCode={filter.clientCode ?? ""} />}
        </Box>
        <WorkbookFilterItemLabelLinkedCounter filter={filter} />
      </Stack>
    </Box>
  );
};

export default WorkbookFilterItemLabel;
